import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button } from "shards-react";
import Layout from "shared/container/LayoutAdmin";
import styled from "styled-components";
import MenuBar from "shared/components/MenuBar/MenuBar";
import useToken from "shared/hook/useToken";
import baseUrl from "config/baseUrl";
import contentimgset from "shared/assets/img/contentimgset.png";
import {
  ModalCreateInteresting,
  ModalDeleteInteresting,
} from "views/InterestingSetting/components";
import { ToastContainer, toast } from "react-toastify";

const axios = require("axios").default;

const StyledTable = styled.table`
  width: 100%;
  thead {
    height: 60px;
  }
  tbody tr td {
    border-bottom: 1px solid #e5e5e5;
    padding: 20px 0;
  }
`;
const StyledMedia = styled.div`
  display: flex;
  align-items: center;
  color: #000;
  .media-icon {
    padding: 20px;
    svg {
      height: 45px;
    }
  }
  .media-body-title {
    font-weight: bold;
    margin-bottom: 10px;
  }
  .media-body-subtitle {
    color: #818181;
  }
  .media-body {
    line-height: 2.5rem;
  }
`;

const InterestingSetting = (props) => {
  const { match } = props;
  const { token } = useToken();
  const [interestingListData, setInterestingListData] = useState(null);
  //   const [openModalCreateContentMain, setOpenModalCreateContentMain] = useState(
  //     false
  //   );
  const [openModalCreateInteresting, setOpenModalCreateInteresting] = useState(
    false
  );
  const [openModalDeleteInteresting, setOpenModalDeleteInteresting] = useState(
    false
  );
  const [interestingEditData, setInterestingEditData] = useState(false);

  useEffect(() => {
    if (token) {
      var data = JSON.stringify({
        params: {
          interestingSettingId: "",
        },
        show: 5,
        page: 1,
        orderBy: "interestingSettingId",
        orderType: "ASC",
      });

      var config = {
        method: "post",
        url: `${baseUrl}/v1/setting/interestingsettinglist`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        data: data,
      };
      axios(config)
        .then((response) => {
          //   setBannerSettingData(response.data);
          setInterestingListData(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [openModalCreateInteresting, openModalDeleteInteresting]);
  const menu = [
    {
      path: "/administratorhome/interesting",
      title: "จัดการตัวชี้วัดที่น่าสนใจ",
    },
  ];
  return (
    <>
      <Layout>
        <ToastContainer />
        <Container>
          <ToastContainer />
          <MenuBar menu={menu} mode="interestingsetting" />
          <Row>
            <Col md="6">
              <h6 className="bold">จัดการตัวชี้วัดที่น่าสนใจ</h6>
            </Col>
            {interestingListData != null &&
              interestingListData.data.length < 4 && (
                <Col md="6" className="text-right">
                  <Button
                    className="btn-white"
                    onClick={() => {
                      setOpenModalCreateInteresting(true);
                      setInterestingEditData(null);
                    }}
                  >
                    + เพิ่มสิ่งที่น่าสนใจ
                  </Button>
                </Col>
              )}
          </Row>
          <hr />
          <Row>
            <Col>
              <StyledTable>
                <thead>
                  <tr>
                    <th style={{ width: "95px" }}>ลำดับหัวข้อ</th>
                    <th>ชื่อตัวชี้วัด</th>
                    <th style={{ width: "150px" }}>เครื่องมือ</th>
                  </tr>
                </thead>
                <tbody>
                  {interestingListData != null &&
                  interestingListData.data.length > 0 ? (
                    interestingListData.data.map((item, key) => (
                      <tr key={key}>
                        <td>{key + 1}</td>
                        <td>
                          <StyledMedia className="media">
                            <img
                              style={{ width: "100px" }}
                              className="mr-3"
                              src={
                                item.interestingSettingPic
                                  ? `${baseUrl}/${item.interestingSettingPic}`
                                  : contentimgset
                              }
                              alt="content"
                            />
                            <div className="media-body">
                              <div>
                                <strong>{`ตัวชี้วัด (ภาษาไทย):`} </strong>
                               {item.interestingSettingName
                                  ? item.interestingSettingName
                                  : "-"}
                              </div>
                              <div>
                                <strong>{`ตัวชี้วัด (ภาษาอังกฤษ):`} </strong>
                               {item.interestingSettingNameEN
                                  ? item.interestingSettingNameEN
                                  : "-"}
                              </div>
                              {/* <div>
                              <strong>หน่วยงานรับผิดชอบ: </strong>
                              {item.indicatorsAgencySettingName
                                ? item.indicatorsAgencySettingName
                                : "-"}
                            </div> */}
                            </div>
                          </StyledMedia>
                        </td>
                        <td>
                          <Button
                            className="btn-white"
                            style={{ marginRight: "15px" }}
                            onClick={() => {
                              setOpenModalCreateInteresting(true);
                              setInterestingEditData(item);
                            }}
                          >
                            แก้ไขข้อมูล
                          </Button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4">ไม่มีข้อมูลตัวชี้วัด</td>
                    </tr>
                  )}
                </tbody>
              </StyledTable>
            </Col>
          </Row>
        </Container>
      </Layout>

      {openModalCreateInteresting && (
        <ModalCreateInteresting
          open={openModalCreateInteresting}
          toggle={() => setOpenModalCreateInteresting(false)}
          openDelete={() => setOpenModalDeleteInteresting(true)}
          data={interestingEditData}
          selectList={interestingListData ? interestingListData.data : []}
        />
      )}

      {/* {openModalDeleteInteresting && (
        <ModalDeleteInteresting
          open={openModalDeleteInteresting}
          toggle={() => setOpenModalDeleteInteresting(false)}
          openEdit={() => setOpenModalCreateInteresting(true)}
          data={interestingEditData}
        />
      )} */}
    </>
  );
};

export default InterestingSetting;
